import React from "react";
import css from "./resume.module.css";

const Detail = ({
  firstDate,
  secondDate,
  diplomaORexperience,
  location,
  decription,
}) => {
  return (
    <div className={css.timelineCard}>
      <span className={css.dateRange}>
        {firstDate} - {secondDate}
      </span>
      <h3 className={css.title}>{diplomaORexperience}</h3>
      <p className={css.location}>{location}</p>
      <p className={css.description}>{decription}</p>
    </div>
  );
};

export default Detail;
